export default {
  ADMIN: 0,
  CREATOR: 1,
  AGENCY: 2,
  MEMBER: 3
};
